var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1768 3.751C9.88706 6.38065 6.79515 9.70176 5.53979 11.1777L2.3165 8.65259C2.23114 8.59121 0.46174 10.1621 0.508732 10.211L6.37894 16.179C6.42209 16.2279 6.48155 16.25 6.54581 16.25C6.55732 16.25 6.57554 16.25 6.59088 16.2462C6.6676 16.2289 6.73282 16.1771 6.76159 16.1004C7.70719 13.6827 10.8298 8.62094 14.8174 4.94979C14.8884 4.88265 14.9133 4.77716 14.874 4.68605C14.873 4.68509 14.2362 3.71456 14.1768 3.751Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7767 3.751C14.4869 6.38065 11.395 9.70176 10.1397 11.1777L7.754 9.40942C7.66865 9.34804 5.89924 10.9189 5.94623 10.9678L10.9788 16.179C11.022 16.2279 11.0814 16.25 11.1457 16.25C11.1572 16.25 11.1754 16.25 11.1908 16.2462C11.2675 16.2289 11.3327 16.1771 11.3615 16.1004C12.3071 13.6827 15.4297 8.62094 19.4173 4.94978C19.4883 4.88265 19.5132 4.77716 19.4739 4.68605C19.4739 4.68605 18.8361 3.71456 18.7767 3.751Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChecked);
export default __webpack_public_path__ + "static/media/messageChecked.f7290539.svg";
export { ForwardRef as ReactComponent };